import client from './client';
import qs from 'qs';

/**
 * 광고상품관리 - 리스트
 */
export const adverManageList = (param) =>
  client.get(`/api/manage/advrtsgoods/advergoods`, param);

/**
 * 광고상품관리 - 상세 리스트
 */
export const adverManageViewList = (parPrdtSeq) =>
  client.get(`/api/manage/advrtsgoods/adverview?` + qs.stringify(parPrdtSeq));

/**
 * 광고상품관리 - 등록
 */
export const adverManageWrite = (params) =>
  client.post(
    `/api/manage/advrtsgoods/write`,
    qs.stringify(params, {
      skipNulls: true,
      strictNullHandling: true,
      filter: function filterFunc(prefix, value) {
        for (let item in value) {
          if (value.hasOwnProperty(item)) {
            const cur = value[item];
            if (cur === '') {
              value[item] = null;
            }
          }
        }
        return value;
      },
    })
  );

/**
 * 광고상품관리 - 수정
 */
export const adverManageEdit = (params) =>
  client.post(
    `/api/manage/advrtsgoods/edit`,
    qs.stringify(params, {
      skipNulls: true,
      strictNullHandling: true,
      filter: function filterFunc(prefix, value) {
        for (let item in value) {
          if (value.hasOwnProperty(item)) {
            const cur = value[item];
            if (cur === '') {
              value[item] = null;
            }
          }
        }
        return value;
      },
    })
  );

/**
 * 광고상품관리 - 삭제
 */
export const adverManageDel = (param) =>
  client.delete(`/api/manage/advrtsgoods/del`, { data: { ...param } });

/**
 * 상품관리 - 상품정보 수집현황
 */
export const ManageGoodsInfoList = (param) =>
  client.get(`/api/manage/goodsinfo/list`, param);

/**
 * 상품관리 - 상품정보 수집현황 - 전체 상품수
 */
export const manageGoodsInfoCount = (params) =>
  client.get(`/api/manage/goodsinfo/list/count`, { params: params });

/**
 * 상품관리 - 상품정보 수집현황 - 상품 업데이트
 */
export const goodsinfoUpdate = (params) =>
  client.put(
    `http://api.mediacategory.com/product`,
    { data: params },
    {
      withCredentials: true,
    }
  );

/**
 * 상품관리 - 상품리뷰수집현황 (광고주)
 */
export const ManageGoodsInfoReviewAdver = (param) =>
  client.get(`/api/manage/goodsinfo/review/adver`, param);

/**
 * 상품관리 - 상품리뷰수집현황 (상품현황)
 */
export const ManageGoodsInfoReviewProduct = (param) =>
  client.get(`/api/manage/goodsinfo/review/product`, param);

/**
 * 상품관리 - 상품리뷰수집현황 (상품현황) - 리뷰 갯수
 */
export const reviewProductCount = (params) =>
  client.get(`/api/manage/goodsinfo/review/product/count`, { params: params });

/**
 * 상품관리 - AI연구소 상품 카테고리[상품별] - 카테고리 리스트
 */
export const aiCategoryList = (params) =>
  client.get(`/api/manage/category/standardGoods`, { params: params });

/**
 * 모비온 상품 수집 광고주 리스트
 */
export const goodsinfoAdverList = (param) =>
  client.get(`/api/manage/goodsinfo/adverList`, { params: param });

/**
 * 상품관리 - AI연구소 상품 카테고리[상품별]
 */
export const aiCategoryProductList = (params) =>
  client.get(`/api/manage/goodsinfo/aiCategory/product`, params);

/**
 * 상품관리 - AI연구소 상품 카테고리[상품별] - 리스트 갯수
 */
export const aiCategoryProductListCount = (params) =>
  client.get(`/api/manage/goodsinfo/aiCategory/product/count`, {
    params: params,
  });

/**
 * 상품관리 - AI연구소 상품 카테고리[카테고리별]
 */
export const aiCategoryCategoryList = (params) =>
  client.get(`/api/manage/goodsinfo/aiCategory/category`, params);

/**
 * 상품관리 - AI연구소 상품 카테고리[카테고리별]
 */
export const aiCategoryCategoryListCount = (params) =>
  client.get(`/api/manage/goodsinfo/aiCategory/category/count`, {
    params: params,
  });

/**
 * 상품관리 - AI연구소 상품 카테고리[카테고리별] - 모든 상품 조회
 */
export const aiCategoryAllItemList = (params) =>
  client.get(`/api/manage/goodsinfo/aiCategory/categorySub`, {
    params: params,
  });

/**
 * 광고유무, 광고상태 수정
 * @param params
 */
export const manageGoodsInfoModify = (params) =>
  client.post('/api/manage/goodsinfo/state', qs.stringify(params));

/**
 * 광고  - 삭제
 */
export const manageGoodsInfoDelete = (params) =>
  client.delete(`/api/manage/goodsinfo/delete`, { data: { ...params } });

/**
 * 일반상품수집현황 - 다중등록
 */
export const goodsInfoUpLoad = (file, config) =>
  client.post(`/api/manage/goodsinfo/upload`, file, config);

/**
 * 일반상품수집현황 - 수기 대량등록
 */
export const goodsInfoHeadUpLoad = (paramsJson) =>
  client.post(`/api/manage/goodsinfo/hand/upload`, paramsJson);

/**
 * AI 연구소 카테고리
 */
export const aiCategoryProduct = (params) =>
  client.get(`/api/manage/aiCategory`, params);
